/**
 * A definite auth failure: the API answered 401.
 * No response at all (network error, abort, timeout) is not one, so the token is kept.
 */
const isAuthFailure = (err) => Boolean(err && err.response && err.response.status === 401);

/**
 * State of the token found in localStorage: 'valid', 'expired' or 'invalid'.
 * decode is jwtDecode, passed in so this stays pure; it throws on a malformed token.
 */
const storedTokenState = (token, nowMs, decode) => {
  let payload;
  try {
    payload = decode(token);
  } catch (e) {
    return 'invalid';
  }
  if (!payload || typeof payload.exp !== 'number') return 'invalid';
  return payload.exp * 1000 > nowMs ? 'valid' : 'expired';
};

module.exports = { isAuthFailure, storedTokenState };
